import { React, useEffect, useState } from 'react'
import { Card, Image, InputGroup } from 'react-bootstrap';
import { Link, useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Col, Row, Button, ButtonGroup, ButtonToolbar, Table, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVideoCamera, faShareNodes, faDownload, faFileAudio, faUser, faLocation, faClock, faPerson, faArrowLeft, faAngleRight, faBook, faMessage } from '@fortawesome/free-solid-svg-icons';
import { faTwitter, faFacebook, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faPhone, faMapLocationDot, faMapLocation, faAddressCard, faAddressBook } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { serverurl } from '../../providers/ServerUrl';
import '../EventDetail.css';
import './TeaTime.css';

export const TeaTime = () => {


    /**********************************************
       POST TEATIME WITH BISHOP FORM DATA TO THE API
     **********************************************/

       const [buttontext, setButtonText] = useState('Send');
       const [message, setMessageText] = useState();
       const [successmessage, setSuccessMessage] = useState();
       const [errormessage, setErrorMessage] = useState();
   
       const [teatimes_name, setTeaTimeName] = useState();
       const [teatimes_quest1, setTeaTimeQuest1] = useState();
       const [teatimes_quest2, setTeaTimeQuest2] = useState();
       const [teatimes_quest3, setTeaTimeQuest3] = useState();
       const [teatimes_attend, setTeaTimeAttend] = useState();
       const [teatimes_eventinfo, setTeaTimeEventInfo] = useState();
       const [teatimes_email, setTeaTimeEmail] = useState();
       
   
       const navigate = useNavigate();

       const handleSelectAttendChange = (e) => {
       setTeaTimeAttend(e.target.value);

       }

       const handleSelectEventInfoChange = (e) => {
       setTeaTimeEventInfo(e.target.value);

       let teatimesemail = document.getElementById('teatimesemail');
       let teatimesemailinput = document.getElementById('teatimesemailinput');    

       
       if(e.target.value === "Yes") {
           //teatimesemailinput.value = '';
           setTeaTimeEmail("");
           teatimesemail.style.display = 'block';
           teatimesemailinput.style.display = 'block';
           teatimesemail.style.width = '100%';
           teatimesemailinput.style.width = '100%';
                           
            if(teatimes_quest2 == null) {
                setTeaTimeQuest2("");
            }
            if(teatimes_quest3 == null) {
                setTeaTimeQuest3("");
            }
       } else {
            setTeaTimeEmail("Not Provided"); 
            teatimesemail.style.display = 'none';
            teatimesemailinput.style.display = 'none';
            teatimesemail.style.width = '100%';
            teatimesemailinput.style.width = '100%';  
                            
            if(teatimes_quest2 == null) {
                setTeaTimeQuest2("");
            }
            if(teatimes_quest3 == null) {
                setTeaTimeQuest3("");
            }    
       }

    }
   
       const Save = async () => {
           setButtonText("Processing");
           if(teatimes_name === "" || teatimes_email === "" || teatimes_quest1 === "" || teatimes_eventinfo === "" || teatimes_attend == "") {
               setMessageText("error");
               setErrorMessage("All Fields are Required Except Questions 2 and 3");
               setButtonText("Send");
           } else {
           try {

               const items = { teatimes_name, teatimes_quest1, teatimes_quest2, teatimes_quest3, teatimes_eventinfo, teatimes_attend, teatimes_email};
               //console.warn(items);
               const result = await axios.post(serverurl + "/api/teatime", items);
               setMessageText("success");
               setSuccessMessage(result.data.message);
               setButtonText("Send");
               console.warn(result);
           
           } catch (error) {
               setMessageText("error");
               setErrorMessage("!!Sorry, The Form Could Not Be Processed");
               setButtonText("Send");
               console.log(error);
           }
         }
       };





    return (
        <div>

            <div>
                <br></br><br></br>
                <div style={{ position: 'relative' }}>
                    <Image fluid src="images/img3.jpg" alt="Card image" id="bannerimg" />
                    <div id="banneroverlay">
                        <div id="bannerid" className='text-center'>
                            <p id="navhistory">
                                <Link to="/" id="homelink" reloadDocument>Home &nbsp; &#60; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Link>
                                <Link to="/teatimes" reloadDocument className='text-white' id="currentlink">TEA TIME WITH BISHOP</Link>
                            </p>
                            <h4>Tea Time</h4>
                        </div>
                    </div>
                </div>
            </div>

            <br></br><br></br>


            <div>
                <Container>
                    <Row>
                        <Col md={12}>
                            <Card id="deptcard">
                                <Card.Header style={{ backgroundColor: '#135592', color: '#fff', fontSize: '20px', textAlign: 'center' }}>
                                    Tea Time With Bishop
                                </Card.Header>
                                <Card.Body>
                                    <Form>

                                        <InputGroup className="mb-3" controlId="">
                                            <Form.Control type="text" size="lg" placeholder="Full Name" style={{ fontSize: '16px', padding: '15px' }}
                                                value={teatimes_name} onChange={(e) => setTeaTimeName(e.target.value)} />
                                        </InputGroup>

                                        <Form.Group className="mb-3" controlId="">
                                            <Form.Control type="text" size="lg" placeholder="Question 1(Required)" style={{ fontSize: '16px', padding: '15px' }}
                                                value={teatimes_quest1} onChange={(e) => setTeaTimeQuest1(e.target.value)} as="textarea" rows={3} />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="">
                                            <Form.Control type="text" size="lg" placeholder="Question 2(Optional)" style={{ fontSize: '16px', padding: '15px' }}
                                                value={teatimes_quest2} onChange={(e) => setTeaTimeQuest2(e.target.value)} as="textarea" rows={3} />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="">
                                            <Form.Control type="text" size="lg" placeholder="Question 3(Optional)" style={{ fontSize: '16px', padding: '15px' }}
                                                value={teatimes_quest3} onChange={(e) => setTeaTimeQuest3(e.target.value)} as="textarea" rows={3} />
                                        </Form.Group>

                                        <InputGroup>
                                        <Form.Select type="text" size="lg" style={{ fontSize: '16px', padding: '15px' }}
                                                value={teatimes_attend} onChange={handleSelectAttendChange} required id='givingformid'>
                                                <option value=''>Can You Attend TTWB?</option>
                                                <option value='No'>No</option>
                                                <option value='Yes, Online'>Yes Online</option>
                                                <option value='Yes, In Person'>Yes, In Person</option>
                                                
                                        </Form.Select>
                                        </InputGroup>

                                        <InputGroup>
                                        <Form.Select type="text" size="lg" style={{ fontSize: '16px', padding: '15px' }}
                                                value={teatimes_eventinfo} onChange={handleSelectEventInfoChange} required id='givingformid'>
                                                <option value=''>I want to receive more information about TTWB events</option>
                                                <option value='No'>No</option>
                                                <option value='Yes'>Yes</option>
                                                
                                        </Form.Select>
                                        </InputGroup>

                                        <InputGroup className="mb-3" controlId="" id='teatimesemail'>        
                                            <Form.Control type="email" size="lg" placeholder="Please Enter Your Email" style={{ fontSize: '16px', padding: '15px' }} id='teatimesemailinput'
                                                value={teatimes_email} onChange={(e) => setTeaTimeEmail(e.target.value)} />
                                      
                                        </InputGroup>


                                        
                                    </Form>
                                    
                                    <div>
                                        {
                                            message === 'success' ?
                                                <div className='alert alert-success alert-sm'>
                                                    {successmessage}
                                                </div> :
                                                ''
                                        }

                                        {
                                            message === 'error' ?
                                                <div className='alert alert-danger alert-sm'>
                                                    {errormessage}
                                                </div> :
                                                ''
                                        }
                                    </div>
                                    <ButtonToolbar
                                        className="justify-content-between"
                                        aria-label="Toolbar with Button groups"
                                    >

                                        <ButtonGroup className="me-4" aria-label="First group">
                                            {
                                                buttontext === "Processing" ?
                                                    <Button class="btn btn-danger" style={{ backgroundColor: '#249D59', color: '#fff', borderRadius: '0', border: 'none', fontWeight: 'bold' }} onClick={Save}>
                                                        {buttontext}
                                                    </Button> :
                                                    ''
                                            }

                                            {
                                                buttontext === "Send" ?
                                                    <Button class="btn btn-danger" style={{ backgroundColor: 'red', color: '#fff', borderRadius: '0', border: 'none', fontWeight: 'bold' }} onClick={Save}>
                                                        {buttontext}
                                                    </Button> :
                                                    ''
                                            }
                                        </ButtonGroup>
                                    </ButtonToolbar>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <br></br>



        </div >
    )
}
